import axios from "axios";

const API =
  process.env
    .REACT_APP_API_URL ||
  "http://localhost:5000";

export const createStaff =
  async (data) => {
    const res =
      await axios.post(
        `${API}/staff/create`,
        data,
        {
          withCredentials: true,
        }
      );

    return res.data;
  };

export const getAllStaff =
  async () => {
    const res =
      await axios.get(
        `${API}/staff/all`,
        {
          withCredentials: true,
        }
      );

    return res.data;
  };

export const getStaffById =
  async (id) => {
    const res =
      await axios.get(
        `${API}/staff/${id}`,
        {
          withCredentials: true,
        }
      );

    return res.data;
  };

export const updateStaff =
  async (id, data) => {
    const res =
      await axios.put(
        `${API}/staff/update/${id}`,
        data,
        {
          withCredentials: true,
        }
      );

    return res.data;
  };

export const toggleStaffStatus =
  async (id) => {
    const res =
      await axios.put(
        `${API}/staff/status/${id}`,
        {},
        {
          withCredentials: true,
        }
      );

    return res.data;
  };

export const resetStaffPassword =
  async (id) => {
    const res =
      await axios.put(
        `${API}/staff/reset-password/${id}`,
        {},
        {
          withCredentials: true,
        }
      );

    return res.data;
  };